import React, { FC, ReactElement } from 'react';
import { Card, Container } from 'react-bootstrap';
import i18next from 'i18next';
import AccountSetupForm from './AccountSetupForm';
import { NavigateFunction, useNavigate } from 'react-router';

const AccountSetupPage: FC = (): ReactElement => {
  const navigate: NavigateFunction = useNavigate();

  return (
    <Container className="h-100">
      <div className="d-flex justify-content-md-center align-items-center vh-100">
        <Card>
          <Card.Body>
            <h3 className='fw-bold mb-3'>{i18next.t('accountSetup.personalDetailLabel')}</h3>
            <AccountSetupForm onSuccess={() => navigate('/patients')} />
          </Card.Body>
        </Card>
      </div>
    </Container>
  );
};

export default AccountSetupPage;

